import { addTraits } from 'src/api';

export const getBackgroundAssessmentLog = state =>
  addTraits(state.backgroundAssessment.backgroundAssessmentLog);

export const getComplianceDashboardData = state =>
  addTraits(state.backgroundAssessment.backgroundAssessment);

export const getComplianceHistory = state =>
  addTraits(state.backgroundAssessment.backgroundAssessment);

export const getComplianceSettings = state =>
  addTraits(state.backgroundAssessment.complianceSettings);

export const getComplianceNotifications = state =>
  addTraits(state.backgroundAssessment.complianceNotifications);
